export enum TableExportMode {
	AllTable = 'all-table',
	SelectedRows = 'selected-rows',
}
